import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-home',
  templateUrl: './chat-home.component.html',
  styleUrls: ['./chat-home.component.scss']
})
export class ChatHomeComponent implements OnInit {

  userflag = false;
  userDetails:any;

  constructor() { }

  ngOnInit(): void {
    this.userDetails = this.getUserInformation();
  }

  selectedUser(event:any) {
    this.userDetails = event;
    this.userflag=true;
  }

  arrowBack(event:any) {
    this.userDetails = this.getUserInformation();
    this.userflag=false;
  }

  getUserInformation() {
    let user:any = sessionStorage.getItem('userInformation')
    return JSON.parse(user);
  }
}
